import React, { useState } from 'react';
import { toast as message } from 'sonner';
import { supabaseClient } from '../../../utils/supabase';
import type { ActionDialogProps } from '../types';
import { useQueryClient } from '@tanstack/react-query';
import EnhancedDialog from '../../EnhancedDialog';

export const AchApproveDialog: React.FC<ActionDialogProps> = ({
  isOpen,
  onClose,
  prefill,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const queryClient = useQueryClient();

  const handleApprove = async () => {
    setSubmitting(true);

    try {
      const { data, error } = await supabaseClient.functions.invoke('ach-charge-approve', {
        body: {
          ach_charge_attempt_id: Number(prefill.ach_charge_attempt_id),
        },
      });

      if (data?.error) throw new Error(data.error);
      if (error) throw error;

      message.success(`Charge approved — status: ${data.charge_status}`);
      onClose();
      queryClient.invalidateQueries({ queryKey: ['action-visibility'] });
      queryClient.invalidateQueries({ predicate: (q) => {
        const key = q.queryKey;
        return Array.isArray(key) && key.some((k) => typeof k === 'string' && (
          k.includes('ach_charge_attempt') || k.includes('ach_mandate') || k.includes('ach_customer')
        ));
      }});
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Failed to approve charge';
      message.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <EnhancedDialog
      isOpen={isOpen}
      onClose={!submitting ? onClose : () => {}}
      title="Approve ACH Charge"
      style={{ width: 420 }}
      canOutsideClickClose={!submitting}
    >
      <div className="sky-dialog-body">
        <div className="sky-callout" style={{ marginBottom: 12 }}>
          Approving this charge will execute it against Stripe. ACH charges typically take 4-5
          business days to settle.
        </div>
        <p>Are you sure you want to approve this charge?</p>
      </div>

      <div className="sky-dialog-footer">
        <button className="sky-btn sky-btn-ghost" onClick={onClose} disabled={submitting}>Cancel</button>
        <button
          className="sky-btn"
          style={{ background: 'var(--green)', color: '#fff' }}
          onClick={handleApprove}
          disabled={submitting}
        >
          {submitting ? <span className="sky-spinner" /> : null}
          Approve Charge
        </button>
      </div>
    </EnhancedDialog>
  );
};
